import React from 'react';
import './AdditionalProducts.css';
import { vehiclesAndBattery } from '../assets/images';

const AdditionalProducts = ({ onOrderNow }) => {
  return (
    <section className="additional-products">
      <div className="container">
        <div className="product-content">
          <div className="product-media">
            <div className="product-image">
              <img 
                src={vehiclesAndBattery} 
                alt="Baterias automotivas para todos os tipos de veículos"
                className="product-img img-transparent img-floating"
                onError={(e) => {
                  e.target.src = '/Imagens/2_dobra_desk.jpg';
                }}
              />
              <div className="product-badges">
                <div className="badge warranty">
                  <span className="badge-number">15</span>
                  <span className="badge-text">meses</span>
                </div>
                <div className="badge original">
                  <span className="badge-text">Peça Original</span>
                </div>
                <div className="badge delivery">
                  <span className="badge-text">✓ Entrega Grátis</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="product-info">
            <h2 className="product-title">
              Baterias para todos os tipos de veículos
            </h2>
            <p className="product-description">
              Temos a bateria ideal para o seu veículo! Desde carros de passeio até veículos pesados. 
              Qualidade garantida com entrega e instalação gratuitas em até 50 minutos.
            </p>
            
            <div className="product-features">
              <div className="feature">
                <span className="feature-icon">🔋</span>
                <span className="feature-text">Alta durabilidade</span>
              </div>
              <div className="feature">
                <span className="feature-icon">⚡</span>
                <span className="feature-text">Carga rápida</span>
              </div>
              <div className="feature">
                <span className="feature-icon">🛡️</span>
                <span className="feature-text">15 meses de garantia</span>
              </div>
            </div>
            
            <button className="btn-primary btn-large" onClick={onOrderNow}>
              PEÇA AGORA
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalProducts;
